export default "__VITE_ASSET__ef4ea906__"